import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { TimeSettingsBreakConfigs } from 'modules/attendance/hooks/useFetchTimeSettingsBreakConfigurations'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import BreakCard from './Card'

interface Props {
  attendanceSetting: AttendanceSetting
  timeSettingsBreakConfigurations: TimeSettingsBreakConfigs[]
}

const PolicyBreakConfigurations = ({
  attendanceSetting,
  timeSettingsBreakConfigurations,
}: Props) => {
  return (
    <Box gap="s16">
      {timeSettingsBreakConfigurations.map(
        (timeSettingsBreakConfiguration: TimeSettingsBreakConfigs) => (
          <BreakCard
            key={timeSettingsBreakConfiguration.id}
            attendanceSetting={attendanceSetting}
            timeSettingsBreakConfiguration={timeSettingsBreakConfiguration}
            timeSettingsBreakConfigurations={timeSettingsBreakConfigurations}
          />
        )
      )}
    </Box>
  )
}

export default PolicyBreakConfigurations
